import React from 'react';
import styled from '@emotion/styled';
import { Wrapper } from './DropdownPanel';
import useOnFocusWithin from '../../hooks/use-on-focus-within';

const FocusWapper = styled.div`
  &:hover ${Wrapper},
  &:focus-within ${Wrapper} {
    max-height: 100vh;
    pointer-events: auto;
    opacity: 1;
    transition: opacity 150ms ease-out;
  }
`;

const DropdownFocusWrapper = ({
  children,
  hasDropdown,
  setIsDropdownOpen
}) => {
  const { onFocus, onBlur } = useOnFocusWithin({
    onFocus: () => setIsDropdownOpen(true),
    onBlur: () => setIsDropdownOpen(false)
  });

  if (!hasDropdown) {
    return children;
  }

  return (
    <FocusWapper
      onMouseEnter={() => setIsDropdownOpen(true)}
      onMouseLeave={() => setIsDropdownOpen(false)}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      {children}
    </FocusWapper>
  );
};

export default DropdownFocusWrapper;
